import { EContentBlockType } from "../../../types/enum";
import { TContentBlock } from "../../../types/types";
import CasesReviewBlock from "../../cases-page/cases-review-block/cases-review-block";
import CasesSwiperBlock from "../../cases-page/cases-swiper-block/cases-swiper-block";
import CasesApproachBlock from "../../cases-page/cases-approach-block/cases-approach-block";
import CasesListBlock from "../../cases-page/cases-list-block/cases-list-block";
import CasesMetricsBlock from "../../cases-page/cases-metrics-block/cases-metrics-block";
import CasesAboutBlock from "../../cases-page/cases-about-block/cases-about-block";
import CasesFeaturedBulletsBlock from "../../cases-page/cases-featured-bullets-block/cases-featured-bullets-block";
import CaseInfoList from "../../main-page/cases-block/case-info/case-info-list";

type Props = {
  contentBlock: TContentBlock;
  previewImageUrl?: string;
};

const CaseParser = ({ contentBlock }: Props) => {
  switch (contentBlock.__component) {
    case EContentBlockType.HEADING_TEXT:
      return (
        <CasesAboutBlock title={contentBlock.heading}>
          {contentBlock.description}
        </CasesAboutBlock>
      );

    case EContentBlockType.HEADLINES_AND_BULLETS:
      return (
        <CasesListBlock
          title={contentBlock.heading}
          ulItems={contentBlock.bullets}
          subheading={contentBlock.subHeading}
        />
      );

    case EContentBlockType.FEATURED_BULLETS:
      return (
        <CasesFeaturedBulletsBlock
          heading={contentBlock.heading}
          featuredBullets={contentBlock.featuredBullets}
        />
      );

    case EContentBlockType.IMAGE_GALLERY:
      return <CasesSwiperBlock images={contentBlock.images} />;

    case EContentBlockType.TEXT_AND_IMAGE:
      return (
        <CasesApproachBlock
          title={contentBlock.heading}
          img={contentBlock.image.url}
          position={contentBlock.imagePosition}
        >
          {contentBlock.text}
        </CasesApproachBlock>
      );

    case EContentBlockType.TESTIMONIAL:
      return (
        <CasesReviewBlock
          title={contentBlock.heading}
          author={contentBlock.quote.author}
          logo={contentBlock.quote.logo}
        >
          {contentBlock.quote.text}
        </CasesReviewBlock>
      );

    case EContentBlockType.METRICS:
      return (
        <CasesMetricsBlock
          heading={contentBlock.heading}
          description={contentBlock.description}
          stats={contentBlock.stats}
        />
      );

    case EContentBlockType.STATS:
      return <CaseInfoList stats={contentBlock.stats} />;

    default:
      return null;
  }
};

export default CaseParser;
